import { PriceAdjustmentType } from "../common/priceAdjustment/enum.priceAdjustmentType";
import { CountryIsoCode } from "../country/enum.countryIsoCode";
import { InvoiceContentPersonalDataType } from "./enum.invoiceContentPersonalDataType";
import { ModalitaPagamentoType } from "./enum.modalitaPagamentoType";
import { TipoDocumentoType } from "./enum.tipoDocumentoType";

export enum NaturaType {
  N1 = "N1",
  N21 = "N2.1",
  N22 = "N2.2",
  N2 = "N2",
  N31 = "N3.1",
  N32 = "N3.2",
  N33 = "N3.3",
  N34 = "N3.4",
  N35 = "N3.5",
  N36 = "N3.6",
  N3 = "N3",
  N4 = "N4",
  N5 = "N5",
  N61 = "N6.1",
  N62 = "N6.2",
  N63 = "N6.3",
  N64 = "N6.4",
  N65 = "N6.5",
  N66 = "N6.6",
  N67 = "N6.7",
  N68 = "N6.8",
  N69 = "N6.9",
  N6 = "N6",
  N7 = "N7",
}

export enum RegimeFiscaleType {
  RF01 = "RF01",
  RF02 = "RF02",
  RF04 = "RF04",
  RF05 = "RF05",
  RF06 = "RF06",
  RF07 = "RF07",
  RF08 = "RF08",
  RF09 = "RF09",
  RF10 = "RF10",
  RF11 = "RF11",
  RF12 = "RF12",
  RF13 = "RF13",
  RF14 = "RF14",
  RF15 = "RF15",
  RF16 = "RF16",
  RF17 = "RF17",
  RF18 = "RF18",
  RF19 = "RF19",
}
export enum CondizioniPagamentoType {
  TP01 = "TP01",
  TP02 = "TP02",
  TP03 = "TP03",
}

/** Italian FeX `SocioUnico` codes (SM/SU). */
export enum SoleShareholderType {
  SM = "SM",
  SU = "SU",
}

/** Italian FeX `StatoLiquidazione` codes (LN/LS). */
export enum LiquidationStatusType {
  LN = "LN",
  LS = "LS",
}

export type InvoiceContentReaRegistration = {
  registerOfficeProvince: string;
  reaNumber: string;
  liquidationStatus: LiquidationStatusType;
  shareCapital?: string;
  soleShareholder?: SoleShareholderType;
};
export type InvoiceContentCommon = {
  invoiceType: TipoDocumentoType;
  currency: "EUR";
  number: string;
  date: string;
  comment?: string;
};

export type InvoiceContentPersonalData =
  | {
      type: InvoiceContentPersonalDataType.COMPANY;
      name: string;
      vatNumber: string;
    }
  | {
      type: InvoiceContentPersonalDataType.PERSON;
      firstName: string;
      lastName: string;
      taxNumber: string;
    };

export type InvoiceContentAddress = {
  province?: undefined | string;
  street: string;
  postalCode: string;
  place: string;
  country: CountryIsoCode;
};

export type InvoiceContentIssuer = {
  contact?:
    | undefined
    | {
        phoneNumber?: undefined | string;
        email?: undefined | string;
        faxNumber?: undefined | string;
      };
  address: InvoiceContentAddress;
  personalData: InvoiceContentPersonalData;
  taxSystem: RegimeFiscaleType;
  reaRegistration?: undefined | InvoiceContentReaRegistration;
};

export type InvoiceContentRecipient = {
  address: InvoiceContentAddress;
  personalData: InvoiceContentPersonalData;
};

export type InvoiceContentItem = {
  startDate?: undefined | string;
  endDate?: undefined | string;
  natura?: undefined | NaturaType;
  description: string;
  quantity: string;
  unitPrice: string;
  vatRate: string;
};

export type InvoiceContentDiscount = {
  type: PriceAdjustmentType;
  value: string;
};

export type InvoiceContentPaymentInfo = {
  paymentConditions: CondizioniPagamentoType;
  details: InvoiceContentPaymentInfoDetails[];
};

export type InvoiceContentPaymentInfoDetails = {
  iban?: undefined | string;
  financialInstitute?: undefined | string;
  bic?: undefined | string;
  paymentMethod: ModalitaPagamentoType;
  value: string;
};

export type InvoiceContent = {
  common: InvoiceContentCommon;
  issuer: InvoiceContentIssuer;
  recipient: InvoiceContentRecipient;
  items: InvoiceContentItem[];
  discounts?: undefined | InvoiceContentDiscount[];
  paymentInfo?: undefined | InvoiceContentPaymentInfo;
};
